import React, { useState, useEffect } from 'react'
import styles from './FeedbackPrompt.module.scss'
import { onChartFeedback } from '../../gaEvents'

const SESSION_KEY = 'lugsail-feedback-given'

export default function FeedbackPrompt({ chartId }) {
  const [visible, setVisible] = useState(false)
  const [phase, setPhase] = useState('prompt') // prompt | missing | done

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (sessionStorage.getItem(SESSION_KEY)) return
    const timer = setTimeout(() => setVisible(true), 3000)
    return () => clearTimeout(timer)
  }, [])

  function markDone() {
    sessionStorage.setItem(SESSION_KEY, '1')
    setVisible(false)
  }

  function handleYes() {
    onChartFeedback(chartId, 'yes')
    setPhase('done')
    setTimeout(markDone, 1200)
  }

  function handleNotYet() {
    onChartFeedback(chartId, 'not_yet')
    setPhase('done')
    setTimeout(markDone, 1200)
  }

  function handleMissingSubmit(text) {
    onChartFeedback(chartId, 'missing', text)
    setPhase('done')
    setTimeout(markDone, 1200)
  }

  if (!visible) return null

  return (
    <div className={styles.prompt}>
      {phase === 'prompt' && (
        <>
          <span className={styles.question}>Did this chart help?</span>
          <div className={styles.actions}>
            <button className={styles.btnYes} onClick={handleYes}>Yes</button>
            <button className={styles.btn} onClick={handleNotYet}>Not yet</button>
            <button className={styles.btn} onClick={() => setPhase('missing')}>
              What's missing?
            </button>
            <button className={styles.dismiss} onClick={markDone} aria-label="Dismiss">×</button>
          </div>
        </>
      )}
      {phase === 'missing' && (
        <MissingInput onSubmit={handleMissingSubmit} onCancel={() => setPhase('prompt')} />
      )}
      {phase === 'done' && (
        <span className={styles.thanks}>Thanks for the feedback.</span>
      )}
    </div>
  )
}

function MissingInput({ onSubmit, onCancel }) {
  const [text, setText] = useState('')
  return (
    <form
      className={styles.missingForm}
      onSubmit={(e) => { e.preventDefault(); if (text.trim()) onSubmit(text.trim()) }}
    >
      <input
        autoFocus
        className={styles.missingInput}
        placeholder="Tell us what you needed…"
        value={text}
        onChange={(e) => setText(e.target.value)}
        maxLength={200}
      />
      <button type="submit" className={styles.btnYes} disabled={!text.trim()}>Send</button>
      <button type="button" className={styles.btn} onClick={onCancel}>Back</button>
    </form>
  )
}
